/**
 * Hiusextra: tuotekorttien swatchien "+n"-laskenta ajoissa.
 *
 * Horizonin <overflow-list> laskee näkyvät swatchit ja "+n"-ruudun vasta, kun sen IntersectionObserver
 * (rootMargin 640 px) huomaa kortin. Työpöydällä (≥ 990 px) sivu vierii kuitenkin .page-wrapperin sisällä,
 * joka leikkaa rootMarginin pois: laskenta tapahtui vasta kortin jo näkyessä, ja kortti hyppäsi
 * kaikista swatcheista (useita rivejä) muotoon 4 + "+n". Tässä sama laskenta käynnistetään
 * (overflow-listin oma reflow-tapahtuma) jo ennen kuin kortti tulee näkyviin oikeaa vierityssäiliötä vasten.
 * Myös myöhemmin lisätyt kortit (suodatus, sivutus) huomioidaan.
 */
(function () {
  const SELECTOR = 'product-card overflow-list';
  const seen = new WeakSet();

  const wrapper = document.querySelector('.page-wrapper');
  const scrollsInside = () => wrapper && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY);

  // overflow-list lisää reflow-kuuntelijansa vasta tyylien latauduttua; laskenta asettaa --overflow-count-muuttujan,
  // joten jos sitä ei vielä ole, yritetään hetken päästä uudelleen.
  // Kuten Horizonin oma IntersectionObserver-polku: listan korkeudeksi yhden swatchin korkeus ennen laskentaa.
  // Ilman sitä "+n"-paikka venyy koko listan korkuiseksi ja kaikki swatchit tulkitaan piiloon jääviksi.
  function reflow(list, tries = 0) {
    const part = list.shadowRoot?.querySelector('[part="list"]');
    const first = Array.from(list.children).find((child) => child.tagName === 'LI' && !child.slot);
    if (part && first && !part.style.height) {
      list.querySelector(':scope > template[shadowrootmode="open"]')?.remove();
      part.style.height = `${first.getBoundingClientRect().height}px`;
    }
    list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    if (!list.style.getPropertyValue('--overflow-count') && tries < 20) {
      setTimeout(() => reflow(list, tries + 1), 150);
    }
  }

  let observer = null;

  function createObserver() {
    observer?.disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          reflow(entry.target);
        }
      },
      { root: scrollsInside() ? wrapper : null, rootMargin: '800px 0px 800px 0px' }
    );
  }

  function observe(root) {
    root.querySelectorAll(SELECTOR).forEach((list) => {
      if (seen.has(list)) return;
      seen.add(list);
      observer.observe(list);
    });
  }

  function init() {
    createObserver();
    observe(document);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('overflow-list')) {
            if (node.closest('product-card')) observe(node.parentElement);
          } else if (node.querySelector('overflow-list')) {
            observe(node);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
